'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Interest;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'interest';

function Interest(_ref) {
  var label = _ref.label,
      values = _ref.values,
      onChange = _ref.onChange;

  if (_config.CLIENT) {
    require('rc-slider/assets/index.css');
  }

  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    _react2.default.createElement(_rcSlider2.default, {
      tipFormatter: null,
      min: 0,
      value: values[0].value,
      max: 10,
      step: 1,
      onChange: onChange
    }),
    _react2.default.createElement(
      'label',
      null,
      label
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Interests/Interest.jsx
// module id = 1231
// module chunks = 0